// client/src/pages/DiscoverViewedDetail.jsx - 从历史进入的详情（仅爱心按钮）
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import request from '../utils/request';
import { useWxShare } from '../hooks/useWxShare';
import { runMatchAfterSubscribe } from '../utils/wxSubscribeMatch';
import GuestDetailContent from '../components/GuestDetailContent';

function DiscoverViewedDetail() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [browse, setBrowse] = useState(null);
  const [gate, setGate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [matching, setMatching] = useState(false);
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [matchMessage, setMatchMessage] = useState('');
  const navigate = useNavigate();

  useWxShare({
    title: user ? `${user.nickname} - AI相亲助手` : 'AI相亲助手 - 发现缘分',
    desc: '智能匹配，轻松脱单',
    imgUrl: user?.avatar
  });

  useEffect(() => {
    fetchUser();
  }, [id]);

  const fetchUser = async () => {
    try {
      setGate(null);
      const res = await request({ url: `/api/user/${id}`, method: 'GET' });
      const payload = res.data;
      if (payload && payload.user !== undefined) {
        setUser(payload.user);
        setBrowse(payload.browse ?? null);
      } else {
        setUser(payload);
        setBrowse(null);
      }
    } catch (err) {
      if (err.response?.status === 403) {
        setGate({
          code: err.response?.data?.code,
          message: err.response?.data?.error || '无权查看'
        });
        setUser(null);
        setBrowse(null);
      } else if (err.response?.status === 404) {
        setUser(null);
      } else {
        console.error('获取用户失败:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleMatch = async (message) => {
    const token = localStorage.getItem('openid_token');
    const openid = localStorage.getItem('openid');
    if (!token && !openid) {
      alert('请先完善个人资料');
      navigate('/profile/edit');
      return;
    }
    const msg = (message || '').trim();
    if (msg && msg.length > 50) {
      alert('留言不能超过50个字');
      return;
    }
    setMatching(true);
    try {
      await runMatchAfterSubscribe(async () => {
        const res = await request({
          url: '/api/match/request',
          method: 'POST',
          data: { targetId: parseInt(id, 10), message: msg || undefined },
        });
        if (res.data?.success) {
          setShowMatchModal(false);
          setMatchMessage('');
          alert(res.data.message || '已发送牵线请求，请等待对方同意');
        }
      });
    } catch (err) {
      const errMsg = err.response?.data?.error || err.message || '牵线失败';
      if (err.response?.data?.needPay) {
        if (window.confirm('您没有可用名额，是否去购买会员？')) {
          setShowMatchModal(false);
          navigate('/membership');
        }
      } else {
        alert(errMsg);
      }
    } finally {
      setMatching(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="loading">加载中...</div>
      </Layout>
    );
  }

  if (gate) {
    return (
      <Layout>
        <div style={{ padding: 20 }}>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/discover/history')} style={{ marginBottom: 16 }}>
            ← 返回历史
          </button>
          <div className="card" style={{ textAlign: 'center', padding: 36 }}>
            <p style={{ fontSize: 16, color: '#333', marginBottom: 24, lineHeight: 1.6 }}>{gate.message}</p>
            {gate.code === 'NEED_LOGIN' && (
              <button type="button" className="btn btn-primary" onClick={() => navigate('/profile/edit')}>
                去登录 / 注册
              </button>
            )}
            {(gate.code === 'NEED_PROFILE' || gate.code === 'NEED_REGISTER') && (
              <button type="button" className="btn btn-primary" onClick={() => navigate('/profile/edit')}>
                去完善资料
              </button>
            )}
          </div>
        </div>
      </Layout>
    );
  }

  if (!user) {
    return (
      <Layout>
        <div className="card" style={{ textAlign: 'center', padding: 50 }}>
          <h2>用户不存在</h2>
          <button className="btn btn-primary" style={{ marginTop: 20 }} onClick={() => navigate('/discover/history')}>
            返回历史
          </button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div
        style={{
          margin: '-16px -16px 0 -16px',
          padding: '16px 16px 24px',
          minHeight: '100%',
          background: 'linear-gradient(180deg, #e8ecf9 0%, #ede9fe 50%, #f5f3ff 100%)',
        }}
      >
        <div style={{ marginBottom: 16 }}>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/discover/history')}
            style={{ padding: '10px 12px' }}
          >
            ← 返回历史
          </button>
        </div>

        <div style={{ paddingBottom: 100 }}>
          <GuestDetailContent user={user} browse={browse} />
        </div>

        {/* 底部：仅圆形爱心（浮动固定） */}
        <div
          style={{
            position: 'fixed',
            bottom: 90,
            left: 0,
            right: 0,
            maxWidth: 500,
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          }}
        >
          <button
            onClick={() => {
              if (browse?.locked) {
                if (browse?.exhausted) {
                  if (browse?.isMember) {
                    alert('今日浏览次数已用完，明天再来吧');
                  } else if (window.confirm('今日免费名额已用完。开通会员可每日查看 10 位异性，是否前往？')) {
                    navigate('/membership');
                  }
                }
                return;
              }
              setMatchMessage('');
              setShowMatchModal(true);
            }}
            disabled={matching}
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              border: 'none',
              background: browse?.locked ? '#ccc' : '#ff6b6b',
              boxShadow: browse?.locked ? 'none' : '0 4px 12px rgba(255,107,107,0.4)',
              fontSize: 28,
              cursor: matching || browse?.locked ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              opacity: matching || browse?.locked ? 0.85 : 1,
            }}
            title={
              browse?.locked && browse?.exhausted
                ? browse?.isMember
                  ? '今日次数已用完'
                  : '今日名额已用完'
                : '牵线'
            }
          >
            ❤
          </button>
        </div>
      </div>

      {showMatchModal && user && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: 16,
          }}
          onClick={() => !matching && setShowMatchModal(false)}
        >
          <div className="card" style={{ maxWidth: 400, width: '100%' }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginBottom: 12 }}>向 {user.nickname} 发起牵线</h3>
            <p style={{ color: '#666', fontSize: 14, marginBottom: 12 }}>留言（可选，最多50字）</p>
            <textarea
              value={matchMessage}
              onChange={(e) => setMatchMessage(e.target.value.slice(0, 50))}
              placeholder="想对 TA 说点什么..."
              maxLength={50}
              rows={3}
              style={{
                width: '100%',
                padding: 10,
                borderRadius: 8,
                marginBottom: 12,
                boxSizing: 'border-box',
                resize: 'vertical',
              }}
            />
            <p style={{ color: '#999', fontSize: 12, marginBottom: 16 }}>{matchMessage.length}/50</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                className="btn btn-secondary"
                style={{ flex: 1 }}
                onClick={() => setShowMatchModal(false)}
                disabled={!!matching}
              >
                取消
              </button>
              <button
                className="btn btn-primary"
                style={{ flex: 1 }}
                onClick={() => handleMatch(matchMessage)}
                disabled={!!matching}
              >
                {matching ? '发送中...' : '发送'}
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default DiscoverViewedDetail;
